// Cloud Run `mixpanel-tracking-proxy` canonical URL: gcloud run services describe … --format='value(status.url)'
export const MIXPANEL_TRACKING_PROXY_HOST = 'https://mixpanel-tracking-proxy-37sheo4piq-no.a.run.app';
/** EU residency: server-side `mixpanel-node` must hit this host (default client uses US). */
export const MIXPANEL_INGEST_HOST = 'api-eu.mixpanel.com';
export const MIXPANEL_PROJECT_TOKEN_TEST = '5b7dd8b53635b40c241f31bcfad3019c';
export const MIXPANEL_PROJECT_TOKEN_PROD = '298855177da1b60c43d26dfcf06ff1cc';
//# sourceMappingURL=MixpanelConfig.js.map